import type { Article } from '@/app_lib/types/Article';
import type { Page } from '@/main/entities/content/articles/Post';

// App Router Page Data
interface PianoArticlePage {
  pageType: PianoPaywallPageType.Article;
  pageData: Article;
}

interface PianoDefaultPage {
  pageType: PianoExperiencePageType.Default;
  pageData: Record<PropertyKey, never>;
}

interface PianoHomepagePage {
  pageType: PianoExperiencePageType.Homepage;
  pageData: Record<PropertyKey, never>;
}

interface PianoSectionPage {
  pageType: PianoExperiencePageType.Section;
  pageData: Record<PropertyKey, never>;
}

export type PianoConfigPage = PianoArticlePage | PianoDefaultPage | PianoSectionPage | PianoHomepagePage; // App router

export interface PagesPianoConfigPage {
  pageType: PianoPageType;
  pageData: Page | Record<PropertyKey, never>;
}

export type PaywallState = 'no-paywall' | 'pending' | 'paywalled';

// These pages can potentially be paywalled (the content can be gated)
export enum PianoPaywallPageType {
  Article = 'Article',
  Ranking = 'Ranking',
  Company = 'Company',
  People = 'People',
}

// These pages can be used for experience targeting, but will not have gated content
export enum PianoExperiencePageType {
  Homepage = 'Homepage',
  Section = 'Section',
  Default = 'Default',
}

export function isPianoPaywallPageType(pageType: PianoPageType): pageType is PianoPaywallPageType {
  return pageType in PianoPaywallPageType;
}

export type PianoPageType = PianoPaywallPageType | PianoExperiencePageType;

export enum PaywallExemptTags {
  AlwaysFree = 'TA-Always Free',
  PersonalFinanceEvergreen = 'TA-Personal Finance Evergreen',
  HealthEvergreen = 'TA-Health Evergreen',
  Bypass = 'TA-Bypass Paywall',
}

export function hasPaywallExemptTag(pianoTags: string[]): boolean {
  return pianoTags.some((tag) => Object.values(PaywallExemptTags).includes(tag as PaywallExemptTags));
}

export interface StandardizedPageData {
  companyHasPaywall: boolean;
  pageType: PianoPageType;
  premiumCategory: string;
  primarySection: string;
  publishDate: string;
  sections: string[];
  tags: string[];
  topics: string[];
}
